import React from 'react';
import { Modal } from 'react-bootstrap';

interface VerificationStimulusModalProps {
    show: boolean;
    onClose: () => void;
    styleCss: string;
    isVerified: boolean;
}

export const VerificationStimulusModal: React.FC<VerificationStimulusModalProps> = ({
    show,
    onClose,
    styleCss,
    isVerified
}) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={styleCss + `-color`}
            centered
        >
            <Modal.Body className="p-0">
                <div className="card card-user shadow-lg">
                    <div className={`card-body p-4 ${styleCss === "dark" ? " pb-0" : ""}`}>
                        {isVerified ? (
                            <>
                                <h5 className="font-weight-bold mb-3">
                                    Add Another Wallet
                                </h5>
                                <p className={`mb-3 ${styleCss === "dark" ? "text-light" : "text-dark"}`}>
                                    You're already verified! To add another wallet:
                                </p>
                                <ol className={`${styleCss === "dark" ? "text-light" : "text-dark"}`}>
                                    <li className="mb-2">Visit <a href="https://verify.degencoinflip.com" target="_blank" rel="noopener noreferrer">verify.degencoinflip.com</a></li>
                                    <li className="mb-2">Connect your wallet</li>
                                    <li className="mb-2">Click "Link Wallets"</li>
                                    <li className="mb-0">Follow the prompts to complete the process</li>
                                </ol>
                            </>
                        ) : (
                            <>
                                <h5 className="font-weight-bold mb-3">
                                    DCF Verification Stimulus Checks
                                </h5>
                                <p className={`mb-3 ${styleCss === "dark" ? "text-light" : "text-dark"}`}>
                                    Help us test our verification platform before it becomes mandatory and earn rewards up to $400 for 45 seconds of your time.
                                </p>
                                <p className={`mb-3 ${styleCss === "dark" ? "text-light" : "text-dark"}`}>
                                    <strong>(limited time, FCFS)</strong>
                                </p>
                                <div className="mb-4">
                                    <img
                                        src="https://i.imgur.com/4bEtGFu.png"
                                        alt="Verification Process"
                                        className="img-fluid rounded"
                                    />
                                </div>
                                <p className={`mb-0 ${styleCss === "dark" ? "text-light" : "text-dark"}`}>
                                    Full Details on Discord: <a href="https://discord.com/channels/923082086372483183/963577333267173387/1367300828477788200" target="_blank" rel="noopener noreferrer">Click here</a>
                                </p>
                            </>
                        )}
                    </div>
                    <div className="card-footer text-center">
                        <button
                            className="btn btn-block w-100 btn-lg my-2 rounded-sm btn-warning"
                            onClick={() => window.open('https://verify.degencoinflip.com', '_blank')}
                        >
                            {isVerified ? 'ADD WALLET' : 'VERIFY NOW'}
                        </button>
                        <button
                            className="btn btn-block w-100 btn-lg mb-2 rounded-sm btn-secondary"
                            onClick={onClose}
                        >
                            CLOSE
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}; 